// HelpBot modules;
import app from './app';

const LogOut = (msg) => {

   if ('string' !== typeof msg) msg = '';

   if (app.state.name_full) {
      app.state.status = app.state.name_full + ' logged out from system'
   }

   app.set_state('access_token'     , '' , false);
   app.set_state('application_id'   , 0  , false);
   app.set_state('login_message'    , msg, false);
   app.set_state('name'             , '' , false);
   app.set_state('name_full'        , '' , false);
   app.set_state('user_access_id'   , 0  , false);
   app.set_state('user_access_list' , [{ application_id: 0, version_id: 0 }] , false);
   app.set_state('user_id'          , 0  , false);
   app.set_state('version_id'       , 0) ;

} // LogOut();

export default LogOut;
